<!-- 基于cup_table组件原有功能二次扩展的新组件（兼容cup_table组件的数据结果）目前主要应用于足球+马拉松+篮球；
  1、新增了固定顶部表格header功能 
  2、新增表格展开行功能
  3、向父组件传递事件
-->

<template>
  <div
    class="marathon_loadTree_table"
    :class="[
      tableMode,
      isClickFlag ? `click leftClo_notClick${initColumnIndex}` : '',
      unClickDetailMode ? 'unClickDetail' : '',
    ]"
    v-show="currThemeObj.cssStyle"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
      :max-height="tableHeightPx ? tableHeightPx : 'auto'"
      header-row-class-name="mixtmt_table_header"
      :header-cell-style="headerRowStyle"
      :cell-style="cellStyle"
      :row-class-name="rowClassName"
      @header-click="headerClick"
      :span-method="arraySpanMethod"
      :cell-class-name="cellClassName"
      :row-style="rowStyle"
    >
      <el-table-column
        v-for="column in compTableColumnData"
        :fixed="column.fixed ? column.fixed : false"
        :prop="column.prop"
        :label="column.label"
        :width="column.widthPx"
        :class-name="column.className ? column.className : ''"
        :key="column.prop"
        :type="expandKey && column.prop === expandKey ? 'expand' : ''"
      >
        <template slot-scope="scope">
          <span
            v-if="column.prop == 'rankNum-teamLogo-teamName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_teamDetail, scope.row)
            "
          >
            <span class="rankNum" v-text="scope.row['rankNum']"></span>
            <span class="teamLogo">
              <img :src="scope.row['teamLogo']" />
            </span>
            <span class="teamName" v-text="scope.row['teamName']"></span>
            <template v-if="rankingStyles">
              <span
                class="rankingStyleLeft"
                :style="rankingStyleLeft(scope.row, rankingStyles)"
              ></span>
            </template>
          </span>
          <span
            v-else-if="column.prop == 'teamRank_lastFive_record'"
            :class="column.prop"
          >
            <template v-if="scope.row['teamRank_lastFive_record']">
              <span
                v-for="(ceil, ceilIndex) in scope.row[
                  'teamRank_lastFive_record'
                ]"
                :class="ceil"
                :key="ceilIndex"
                v-text="teamRank_lastFive_record_handler(ceil)"
              ></span>
            </template>
          </span>
          <span
            v-else-if="column.prop == 'teamLogo-teamName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_teamDetail, scope.row)
            "
          >
            <span class="teamLogo">
              <img :src="scope.row['teamLogo']" />
            </span>
            <span class="teamName" v-text="scope.row['teamName']"></span>
          </span>
          <span
            v-else-if="column.prop == 'rankNum-playerLogo-playerName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_playerDetail, scope.row)
            "
          >
            <span class="rankNum" v-text="scope.row['rankNum']"></span>
            <span
              class="playerLogo"
              :class="scope.row['playerLogo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['playerLogo']"
                :src="scope.row['playerLogo']"
              />
            </span>
            <span class="playerName" v-text="scope.row['playerName']"></span>
          </span>
          <span
            v-else-if="column.prop == 'shirtNumber-playerLogo-playerName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_playerDetail, scope.row)
            "
          >
            <span
              class="playerLogo"
              :class="scope.row['playerLogo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['playerLogo']"
                :src="scope.row['playerLogo']"
              />
            </span>
            <span class="playerOther">
              <span
                class="playerName"
                :class="scope.row['shirtNumber'] ? 'twoRow' : ''"
                v-text="scope.row['playerName']"
              ></span>
              <span
                class="shirtNumber"
                v-text="
                  scope.row['shirtNumber'] ? `#${scope.row['shirtNumber']}` : ''
                "
              ></span>
            </span>
          </span>
          <span
            v-else-if="column.prop == 'rankNum-playerLogo-playerName-shirtNumber'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_playerDetail, scope.row)
            "
          >
            <span class="rankNum" v-text="scope.row['rankNum']"></span>
            <span
              class="playerLogo"
              :class="scope.row['playerLogo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['playerLogo']"
                :src="scope.row['playerLogo']"
              />
            </span>
            <span class="playerOther">
              <span
                class="playerName"
                :class="scope.row['shirtNumber'] ? 'twoRow' : ''"
                v-text="scope.row['playerName']"
              ></span>
              <span
                class="shirtNumber"
                v-text="
                  scope.row['shirtNumber'] ? `#${scope.row['shirtNumber']}` : ''
                "
              ></span>
            </span>
          </span>
          <span
            v-else-if="column.prop == 'leftTeamName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_teamDetail, scope.row)
            "
            v-text="scope.row['teamName']"
          ></span>
          <span
            v-else-if="column.prop == 'leftPlayerName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_playerDetail, scope.row)
            "
            v-text="scope.row['playerName']"
          ></span>
          <span
            v-else-if="column.prop == 'teamName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_teamDetail, scope.row)
            "
            v-text="scope.row['teamName']"
          ></span>
          <span
            v-else-if="column.prop == 'playerName'"
            :class="column.prop"
            @click="
              goDetail(jumpRouterPathNames.pathName_playerDetail, scope.row)
            "
            v-text="scope.row['playerName']"
          ></span>
          <span
            v-else-if="column.prop === 'matchDate-homeTeam-awayTeam'"
            class="flexCloCenter"
            @click="
              goDetail(jumpRouterPathNames.pathName_matchDetail, scope.row)
            "
          >
            <span v-text="scope.row['matchDate']"></span>
            <span
              v-text="`${scope.row['homeTeam']} vs ${scope.row['awayTeam']}`"
            ></span>
          </span>
          <span
            v-else-if="
              tableCustomCellRender &&
              tableCustomCellRender.props.includes(column.prop)
            "
            :class="
              tableCustomCellRender.classNames[
                tableCustomCellRender.props.indexOf(column.prop)
              ]
            "
          >
            <template v-if="scope.row[`${column.prop}_web`]">
              <span
                v-for="(cellItem, cellIndex) in scope.row[`${column.prop}_web`]"
                :key="cellIndex"
                v-text="cellItem"
              ></span>
            </template>
          </span>
          <span
            v-else-if="
              column.prop == 'rankNum-playerLogo-playerName-shirtNumber-sex'
            "
            :class="column.prop"
          >
            <span
              class="rankNum"
              v-if="scope.row['rankNum']"
              v-text="scope.row['rankNum']"
            ></span>
            <span
              class="playerLogo"
              :class="scope.row['playerLogo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['playerLogo']"
                :src="scope.row['playerLogo']"
              />
            </span>
            <span class="otherArea">
              <span
                class="athleteName"
                v-text="scope.row['athleteName']"
              ></span>
              <span
                class="numSex"
                v-text="
                  `${scope.row['athleteNum'] ? scope.row['athleteNum'] : ''} ${
                    scope.row['genderName'] ? scope.row['genderName'] : ''
                  }`
                "
              ></span>
            </span>
          </span>
          <span
            v-else-if="
              column.prop == 'marathon_scoresArr' &&
              tableMode === 'marathonGamesTimeResults' &&
              scope.row['scores'] &&
              scope.row['scores'].length > 0
            "
            :class="[column.prop, scope.row.isOpen ? 'open' : '']"
            @click="openItemData(scope.row)"
          >
            <span
              v-for="scoreItem in scope.row['scores']"
              class="scoreItem"
              :key="scoreItem.name"
            >
              <span v-text="scoreItem.name ? `${scoreItem.name}：` : ''"></span>
              <span
                v-text="scoreItem.score ? `${scoreItem.score}` : '-'"
              ></span>
            </span>
            <span class="arrow_icon el-icon-caret-bottom"></span>
          </span>
          <span
            v-else-if="
              column.prop == 'operateArr' &&
              tableMode === 'marathonPlayerCollectionData'
            "
            :class="column.prop"
          >
            <span
              v-text="'合成锦集'"
              class="operateArr_btn"
              @click="
                toParentEvent({
                  eventName: 'marathonPlayerCollectionData_singleSynthesis',
                  data: scope.row,
                })
              "
            ></span>
            <span
              v-text="'发布锦集'"
              class="operateArr_btn"
              @click="
                toParentEvent({
                  eventName: 'marathonPlayerCollectionData_singlePublish',
                  data: scope.row,
                })
              "
            ></span>
          </span>
          <span
            v-else-if="
              column.prop == 'collectionArr' &&
              tableMode === 'marathonPlayerCollectionData'
            "
            :class="column.prop"
          >
            <span v-if="scope.row.highlightStatus === 3">
              <i
                class="videoIcon"
                @click="
                  toParentEvent({
                    eventName: 'marathonPlayerCollectionData_singleVideo',
                    data: scope.row,
                  })
                "
              ></i>
            </span>
            <!-- disabled：0，文字展示禁用 -->
            <span
              v-text="scope.row.disabled - 0 ? '开启' : '禁用'"
              class="collectionArr_btn"
              :class="scope.row.disabled - 0 ? 'disabled' : 'notDisabled'"
              @click="
                toParentEvent({
                  eventName: 'marathonPlayerCollectionData_singleDisabled',
                  data: scope.row,
                })
              "
            ></span>
          </span>
          <span
            v-else-if="
              column.prop == 'operateArr' && tableMode === 'marathonPlayerData'
            "
            :class="column.prop"
          >
            <span
              v-text="'生产切片'"
              class="operateArr_btn"
              @click="
                toParentEvent({
                  eventName: 'marathonPlayerData_singlePlayerSection',
                  data: scope.row,
                })
              "
            ></span>
          </span>
          <span v-else-if="column.prop === expandKey" class="expandBox">
            <span class="expand_header">
              <span class="expand_header_row">
                <span
                  v-for="row in expandColumnData"
                  :key="row.key"
                  :class="row.className"
                  v-text="row.name"
                ></span>
              </span>
            </span>
            <span class="expand_body">
              <span
                class="expand_body_row"
                v-for="row in scope.row[expandKey]"
                :key="row.id"
              >
                <span
                  v-for="col in expandColumnData"
                  :key="col.key"
                  :class="col.className"
                >
                  <span v-if="col.key === 'clipObject'">
                    <i
                      class="videoIcon"
                      @click="
                        toParentEvent({
                          eventName: 'marathonPlayerData_singleClipVideo',
                          data: row,
                          athleteName: scope.row['athleteName']
                            ? scope.row['athleteName']
                            : '',
                          athleteNum: scope.row['athleteNum']
                            ? scope.row['athleteNum']
                            : '',
                        })
                      "
                    ></i>
                  </span>
                  <span v-else v-text="row[col.key]"></span>
                </span>
                <span class="expandBtns widthFlex" v-if="row.id">
                  <span
                    class="btn"
                    v-text="'编辑时间'"
                    @click="
                      toParentEvent({
                        eventName: 'marathonPlayerData_editTime',
                        data: row,
                        athleteName: scope.row['athleteName']
                          ? scope.row['athleteName']
                          : '',
                        athleteNum: scope.row['athleteNum']
                          ? scope.row['athleteNum']
                          : '',
                      })
                    "
                  ></span>
                  <span
                    class="btn"
                    v-text="'生成切片'"
                    @click="
                      toParentEvent({
                        eventName: 'marathonPlayerData_singleCameraSection',
                        data: row,
                        athleteName: scope.row['athleteName']
                          ? scope.row['athleteName']
                          : '',
                        athleteNum: scope.row['athleteNum']
                          ? scope.row['athleteNum']
                          : '',
                      })
                    "
                  ></span>
                </span>
              </span>
            </span>
          </span>
          <span
            v-else
            v-text="_valFormatHandler(scope.row[scope.column.property])"
          ></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'marathon_loadTree_table',
  mixins: [cup_base_data_mixin],
  props: {
    expandKey: {
      type: String,
      default: 'isExpand', //占用展开的id
    },
    expandColumnData: {
      type: Array,
      default: () => {
        return [
          {
            name: '摄像机位',
            className: 'width30Per',
            key: 'streamName',
          },
          {
            name: '视频切片',
            className: 'width20Per',
            key: 'clipObject',
          },
          {
            name: '机位前切片时间（秒）',
            className: 'width20Per',
            key: 'clipOffset',
          },
        ]
      },
    },
    tableMode: {
      type: String,
      default: '', //类型，比如leagueTable对应积分榜表格
    },
    isBroadCastList: {
      //播出单页面不能点击跳转详情
      type: Boolean,
      default: false,
    },
    isClickFlag: {
      type: Boolean,
      default: false,
    },
    initColumnIndex: {
      //初始化表格赋值从某一列高亮
      type: Number,
      default: 1,
    },
    parentWidthPx: {
      type: Number, //父级宽度，做监听，因为自适应
      default: 1160,
    },
    tableHeightPx: {
      type: Number,
      default: 0,
    },
    isScrollFlag: {
      type: Boolean, // 是否横向滚动
      default: false,
    },
    variableColWidthVw: {
      type: Number, // 这个在每个table中是唯一的值,不允许出现重复，否则动态计算有问题(将富裕的零碎像素加到这列中)；只有tableCellDefaultWidthVw和variableColWidthVw相同的值在动态计算时会有变化，其他列设置的widthVw值都不会变化
      default: 25.42,
    },
    tableCellDefaultWidthVw: {
      type: Number, // 默认列队宽度，根据自适应计算，不滚动时会变大变小；滚动时只会变大
      default: 5.55,
    },
    defaultWidthVwNum: {
      type: Number, // 默认列的的个数，动态计算时需要
      default: 8,
    },
    tableColumnData: {
      type: Array, // 表格头部的数据
      default: () => {
        return [
          {
            prop: 'date',
            label: '日期',
            widthVw: 25.42, //对应列的宽度，单位vw
            className: 'columnNumLogoNameClass', //单独定制的头部样式class
            fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          },
          {
            prop: 'matchesPlayed',
            label: '场次',
            widthVw: 5.55,
          },
          {
            prop: 'matchesWon',
            label: '胜',
            widthVw: 5.55,
          },
          {
            prop: 'matchesDrawn',
            label: '平',
            widthVw: 5.55,
          },
          {
            prop: 'matchesLost',
            label: '负',
            widthVw: 5.55,
          },
          {
            prop: 'goalsFor',
            label: '进球',
            widthVw: 5.55,
          },
          {
            prop: 'goalsAgainst',
            label: '失球',
            widthVw: 5.55,
          },
          {
            prop: 'goalsDifference',
            label: '净胜球',
            widthVw: 5.55,
          },
          {
            prop: 'points',
            label: '积分',
            widthVw: 5.55,
          },
          // {
          //   prop: 'war',
          //   label: '邮编12',
          //   widthVw: 10,
          //   fixed: 'right',
          // },
        ]
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [
          {
            date: '2016-05-03',
            matchesPlayed: 20,
            matchesWon: 20,
            matchesDrawn: 99,
            matchesLost: 1234,
            goalsFor: 200333,
            goalsAgainst: 1,
            points: 231,
            war: '1212aasdad',
          },
          {
            date: '2016-05-02',
            matchesPlayed: 90,
            matchesWon: 92,
            matchesDrawn: 100,
            matchesLost: 2311,
            goalsFor: 200333,
            goalsAgainst: 2,
            points: 123,
            war: '1212aasdad',
          },
        ]
      },
    },
    rowClassName: {
      type: [String, Function],
      default: null,
    },
    rowStyle: {
      type: [String, Function],
      default: null,
    },
    jumpRouterPathNames: {
      type: Object,
      default: () => ({
        pathName_teamDetail: '',
        pathName_playerDetail: '',
      }),
    },
    arraySpanMethod: {
      type: Function,
      default: () => {},
    },
    cellClassName: {
      type: [String, Function],
      default: null,
    },
    tableCustomCellRender: {
      type: [Object, null],
      default: () => ({
        props: [],
        classNames: [],
      }),
    },
    valFormatReturnDefaultVal: {
      // 格式化没有数据时，返回的默认值
      type: String,
      default: '',
    },
    tableKey: {
      type: String,
      default: '',
    },
    rankingStyles: {
      type: [Array, null],
      default: null,
    },
    unClickDetailMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortStartColumnIndex: 1, // 默认一般都是从第2列可以点击表头排序
    }
  },
  created() {
    this.sortStartColumnIndex = this.initColumnIndex
  },
  computed: {
    compTableColumnData() {
      let maxColWidthPx = Math.ceil(
        this.variableColWidthVw * (this.clientWidth / 100)
      )
      // let scrollAreaPx
      let estimateAllTableWidth = 0
      let tableCellDefaultWidthPx = Math.ceil(
        this.tableCellDefaultWidthVw * (this.clientWidth / 100)
      )
      this.tableColumnData.forEach((col) => {
        estimateAllTableWidth += Math.ceil(
          col.widthVw * (this.clientWidth / 100)
        )
      })
      const totalColumnNum = this.tableColumnData
        ? this.tableColumnData.length
        : 0
      let maxColWidthPxArr = null
      console.debug(
        'estimateAllTableWidth:',
        this.parentWidthPx,
        estimateAllTableWidth,
        tableCellDefaultWidthPx,
        this.isScrollFlag
      )
      let diffVal = estimateAllTableWidth - this.parentWidthPx
      if (diffVal > 0) {
        // 超出了
        let singlePx = Math.floor(diffVal / this.defaultWidthVwNum)
        console.debug('超出了', diffVal, singlePx, tableCellDefaultWidthPx)

        // 这里要区分是否有滚动区域，
        if (this.isScrollFlag) {
          if (singlePx == 0) {
            // 不够平分的，将每一个默认的宽度值-1，剩下多余的加到最大的列
            tableCellDefaultWidthPx--
            // maxColWidthPx = this.defaultWidthVwNum - singlePx
            maxColWidthPx += this.defaultWidthVwNum - diffVal
          } else {
            // 需要滚动逻辑，滚动需要最后一个露出半个
            // 计算可滚动的区域宽度
            let scrollAreaPx =
              this.defaultWidthVwNum * tableCellDefaultWidthPx - diffVal
            let scrollAreaNum = Math.floor(
              scrollAreaPx / tableCellDefaultWidthPx
            )
            console.debug(
              'scrollAreaPx:',
              scrollAreaPx,
              this.defaultWidthVwNum,
              this.defaultWidthVwNum * tableCellDefaultWidthPx,
              scrollAreaNum
            )
            if (scrollAreaNum > 0) {
              // 可滚动区域最少可以放1列以上的
              scrollAreaNum += 0.5
              console.debug(Math.ceil(scrollAreaNum * tableCellDefaultWidthPx))
              if (
                Math.ceil(scrollAreaNum * tableCellDefaultWidthPx) >
                scrollAreaPx
              ) {
                console.debug('可滚动区域小于x.5列的总宽度')
                // 可滚动区域小于x.5列的总宽度,则只能减掉1列，平分空间
                scrollAreaNum--
              }
              tableCellDefaultWidthPx = Math.floor(scrollAreaPx / scrollAreaNum)

              if (tableCellDefaultWidthPx % 2 != 0) {
                // 保证tableCellDefaultWidthPx是个偶数，这样乘以x.5才是得出才是整数
                tableCellDefaultWidthPx--
              }
              maxColWidthPx +=
                scrollAreaPx - tableCellDefaultWidthPx * scrollAreaNum
            } else {
              console.debug('不够1列，暂时不考虑')
            }
          }
        } else {
          if (singlePx == 0) {
            // 如果不滚动则走下面的逻辑
            // 不够平分的，将每一个默认的宽度值-1，剩下多余的加到最大的列
            tableCellDefaultWidthPx--
            maxColWidthPx += this.defaultWidthVwNum - diffVal
          } else {
            // 够平分
            tableCellDefaultWidthPx -= singlePx
            maxColWidthPx -= diffVal % this.defaultWidthVwNum
          }
        }
      } else if (diffVal < 0) {
        // 还有剩余空间,不会出现需要滚动，因为空间有富裕
        console.debug('还有剩余空间', diffVal)
        diffVal = Math.abs(diffVal)
        if (this.defaultWidthVwNum === 1) {
          // 只有一个平均列时，将多余的全部给最大列
          maxColWidthPx += diffVal
        } else {
          let singlePx = Math.floor(diffVal / this.defaultWidthVwNum)

          if (singlePx == 0) {
            // 不够平分的，将多余的直接加到最大的列
            maxColWidthPx += singlePx
          } else {
            // 够平分
            tableCellDefaultWidthPx += singlePx
            const maxColWidthNum = totalColumnNum - this.defaultWidthVwNum
            if (maxColWidthNum > 1) {
              // 当出现2个最多列以上的情况
              const forNum = diffVal % this.defaultWidthVwNum
              if (forNum) {
                maxColWidthPxArr = []
                // forNum大于0则要平分
                for (let i = 0; i < maxColWidthNum; i++) {
                  maxColWidthPxArr.push(0)
                }
                for (let i = 0; i < forNum; i++) {
                  maxColWidthPxArr[forNum % maxColWidthNum] += 1
                }
                console.debug('maxColWidthPxArr:', maxColWidthPxArr)
              }
            } else {
              maxColWidthPx += diffVal % this.defaultWidthVwNum
            }
            console.debug(
              '够平分',
              singlePx,
              tableCellDefaultWidthPx,
              maxColWidthPx,
              this.defaultWidthVwNum
            )
          }
        }
      } else {
        // 相等
      }
      maxColWidthPx = maxColWidthPx.toFixed(2)
      console.debug(tableCellDefaultWidthPx, maxColWidthPx)
      return this.tableColumnData.map((col) => {
        if (col.widthVw == this.tableCellDefaultWidthVw) {
          col.widthPx = tableCellDefaultWidthPx
        } else if (col.widthVw == this.variableColWidthVw) {
          col.widthPx =
            maxColWidthPx + (maxColWidthPxArr ? maxColWidthPxArr.pop() : 0)
        } else {
          col.widthPx = Math.ceil(col.widthVw * (this.clientWidth / 100))
        }
        return col
      })
    },
  },
  methods: {
    openItemData(item) {
      item.isOpen = !item.isOpen
    },
    toParentEvent(data) {
      this.$emit('toParentEvent', data)
    },
    headerRowStyle(row, rowIndex) {
      //  console.debug(row, rowIndex)
      var style = {}
      if (this.isClickFlag) {
        if (this.sortStartColumnIndex == row.columnIndex) {
          style = {
            borderTop: `2px solid ${this.currThemeObj.cssStyle.mainColor5}`,
            backgroundColor: this.currThemeObj.cssStyle.table_hoverRowColorBg,
            color: this.currThemeObj.cssStyle.greyColor2,
          }
        }
      }
      return style
    },
    cellStyle(row) {
      //  console.debug(row)
      if (!this.isClickFlag) return
      if (this.sortStartColumnIndex == row.columnIndex) {
        return {
          backgroundColor: `${this.currThemeObj.cssStyle.table_hoverRowColorBg}`,
        }
      }
    },
    headerClick(column, event) {
      if (!this.isClickFlag) return
      console.debug(column, event)
      let columnIndex = -1
      this.tableColumnData.forEach((col, colIndex) => {
        if (col.prop == column.property) {
          columnIndex = colIndex
        }
      })
      console.debug('columnIndex:', this.sortStartColumnIndex)
      if (columnIndex < 1) return //数组下标0 为字段：球队
      this.sortStartColumnIndex = columnIndex
      console.debug('columnIndex:', this.sortStartColumnIndex)
      if (this.tableKey) {
        this.$emit('clickColumnEvent', {
          tableKey: this.tableKey,
          sortKey: column.property,
        })
      } else {
        this.$emit('clickColumnEvent', column.property)
      }
    },
    rankingStyleLeft(item, rankingStylesArr) {
      let style = {}
      if (item && item.styleId && rankingStylesArr) {
        rankingStylesArr.forEach((styleItem) => {
          if (styleItem.styleId === item.styleId) {
            style = {
              backgroundColor: `#${styleItem.barColor}`,
            }
          }
        })
      }
      return style
    },
    teamRank_lastFive_record_handler(val) {
      let name = ''
      if (val === 'W') {
        name = '胜'
      } else if (val === 'L') {
        name = '负'
      } else if (val === 'D') {
        name = '平'
      }
      return name
    },
    _valFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return this.valFormatReturnDefaultVal
          ? this.valFormatReturnDefaultVal
          : ''
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    goDetail(routerName, item) {
      console.debug('item:', item, routerName)
      if (this.isBroadCastList || this.unClickDetailMode) return
      if (!routerName) {
        console.debug('没有传调整页面的路由名字')
      }
      let query = {
        cid: this.currCid,
        sid: this.currSid,
      }
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      if ([`scheduleDetailIndex_${moduleRouteNameEn}`].includes(routerName)) {
        query.mid = item.matchId
        query.sid = item.seasonId
      } else {
        query.tid = item.teamId
        if (
          [
            `teamDetailIndex_${moduleRouteNameEn}`,
            `playerDetailIndex_${moduleRouteNameEn}`,
          ].includes(routerName) &&
          this.currThemeObj.fixHeaderHasSeason === false
        ) {
          // cba|csl 等联赛 赛季id取当前item里面的，不能用 currSid
          query.sid = item.seasonId
        }
        if ([`playerDetailIndex_${moduleRouteNameEn}`].includes(routerName)) {
          query.pid = item.playerId
        }
        if ([`teamDetailIndex_${moduleRouteNameEn}`].includes(routerName)) {
          this.$localStorage.setItem(
            'mixtmt_teamDetail',
            JSON.stringify({
              teamName: item.teamName,
              teamLogo: item.teamLogo,
              teamId: item.teamId,
            })
          )
        }
      }

      this.pageJump(this.$router, routerName, query)
    },
  },
}
</script>

<style lang="scss" scoped>
.marathon_loadTree_table {
  position: relative;
  width: 100%;
  .expandBox {
    display: block;
    width: 100%;
    height: auto;
    .expand_header_row,
    .expand_body_row {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 1.33333vw;
      width: 100%;
      & > span {
        padding: 0 2.083vw;
        text-align: center;
        font-size: 0.972vw;
      }
      & > span:first-child {
        text-align: left;
      }
      .width15Per {
        width: 15%;
      }
      .width20Per {
        width: 20%;
      }
      .width30Per {
        width: 30%;
      }
      .width40Per {
        width: 40%;
      }
      .widthFlex {
        flex: 1;
      }
    }
    .expand_header,
    .expand_body {
      display: block;
      width: 100%;
      height: auto;
    }
    .expand_header_row {
      height: 2.778vw;
      color: var(--mixtmt_whiteColor);
      background-color: var(--mixtmt_mainColor6);
    }
    .expand_body_row {
      height: 3.472vw;
      color: var(--mixtmt_mainColor6);
      background-color: var(--mixtmt_mainColor4);
      .videoIcon {
        display: inline-block;
        width: 1.805vw;
        height: 2.083vw;
        background-image: var(--mixtmt_defaultBg_videoIcon);
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
      }
      .expandBtns {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .btn {
          position: relative;
          width: 5.556vw;
          height: 2.083vw;
          line-height: 2.083vw;
          font-size: 1.11vw;
          text-align: center;
          color: var(--mixtmt_mainColor6);
          margin-left: 1.388vw;
          &:first-child {
            margin-left: 0;
          }
          &::before {
            pointer-events: none;
            position: absolute;
            content: '\20';
            left: 0;
            top: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            border: 1px solid var(--mixtmt_mainColor6);
            border-radius: 0.278vw;
          }
        }
      }
    }
  }
  .collectionArr {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    height: 3.472vw;
    color: var(--mixtmt_mainColor6);
    .videoIcon {
      display: inline-block;
      width: 1.805vw;
      height: 2.083vw;
      background-image: var(--mixtmt_defaultBg_videoIcon);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
    .collectionArr_btn {
      margin-left: 1.388vw;
      width: 5.556vw;
      text-align: center;
      height: 2.083vw;
      border-radius: 0.208vw;
      font-size: 0.972vw;
      line-height: 2.083vw;
      &.disabled {
        border: 1px solid var(--mixtmt_greyColor7);
        color: var(--mixtmt_table_headerBg);
      }
      &.notDisabled {
        border: 1px solid var(--mixtmt_subColor3_1);
        color: var(--mixtmt_subColor3_1);
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.mixtmt_pc {
  .marathon_loadTree_table {
    .expand_body_row {
      &:hover {
        color: var(--mixtmt_table_headerColor);
        background-color: var(--mixtmt_table_headerBg);
        .expandBtns {
          .btn {
            color: var(--mixtmt_table_hoverRowColor);
            &::before {
              border: 1px solid var(--mixtmt_table_hoverRowColor);
            }
          }
        }
        .videoIcon {
          background-image: var(--mixtmt_activeBg_videoIcon);
        }
      }
      .expandBtns {
        .btn {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .videoIcon {
      &:hover {
        cursor: pointer;
      }
    }
    .collectionArr {
      .videoIcon {
        &:hover {
          background-image: var(--mixtmt_activeBg_videoIcon);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.marathon_loadTree_table {
  &.leagueCBA,
  &.basketballCup {
    .el-table {
      .mixtmt_table_header {
        th.el-table__cell {
          background-color: var(--mixtmt_table_headerBg);
          color: var(--mixtmt_table_headerColor);
          font-weight: bold;
          &.leftTeamName,
          &.leftPlayerName,
          &.rankNum-teamLogo-teamName,
          &.teamLogo-teamName,
          &.rankNum-playerLogo-playerName,
          &.rankNum-playerLogo-playerName-shirtNumber,
          &.shirtNumber-playerLogo-playerName {
            .cell {
              padding-left: 1.388vw;
              text-align: left;
            }
          }
        }
      }
    }
  }
  &.marathonGamesTimeResults {
    .el-table {
      .el-table__cell {
        vertical-align: top;
      }
      .cell {
        line-height: 3.82vw;
      }
    }
  }
  .el-table {
    font-size: 0;
    .mixtmt_table_header {
      th.el-table__cell {
        /* padding: 0.972vw 0; */
        padding: 0.694vw 0;
        background-color: var(--mixtmt_table_headerBg);
        color: var(--mixtmt_table_headerColor);
        height: 3.332vw;
        & > .cell {
          padding: 0;
          font-size: 0.974vw;
          line-height: 1.388vw;
          text-align: center;
        }
        &.columnNumLogoNameClass {
          & > .cell {
            padding-left: 3.472vw;
            text-align: left;
          }
        }
        &.columnLogoNameClass {
          & > .cell {
            padding-left: 1.33333vw;
            text-align: left;
          }
        }
        &.columnTeamNameClass {
          & > .cell {
            padding-left: 1.333vw;
            text-align: left;
          }
        }
        &.customCloTextAlignLeft {
          & > .cell {
            padding-left: 1.333vw;
            text-align: left;
          }
        }
      }
    }
    .unPlayRow {
      background-color: var(--mixtmt_greyColor14);
    }
    .el-table__cell {
      /* padding: 0.833vw 0; */
      padding: 0.694vw 0;
      &.cell_clo2Row,
      &.matchDate-homeTeam-awayTeam {
        padding: 0.278vw 0;
      }
      &.customCloTextAlignLeft {
        & > .cell {
          padding-left: 1.333vw;
          text-align: left;
        }
      }
    }
    .el-table__expanded-cell {
      padding: 0;
    }
    .cell {
      font-size: 0.833vw;
      line-height: 1.25vw;
      text-align: center;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .columnNumLogoNameClass {
      .cell {
        text-align: left;
      }
    }
    .basketballLeague_teamRank {
      &.borderBottom {
        position: relative;
        .el-table__cell {
          border-bottom: 1px dashed transparent;
        }
      }
      &.borderBottom::after {
        content: '\20';
        position: absolute;
        left: 0;
        z-index: 2;
        width: 100%;
      }
      &.border_solid::after {
        border-bottom: 1px solid var(--mixtmt_greyColor6);
      }
      &.border_dashed::after {
        border-bottom: 1px dashed var(--mixtmt_subColor1_1);
      }
      &.common_css::after {
        bottom: 0;
        height: 1px;
      }
      &.safari_css::after {
        pointer-events: none;
        height: calc(2.083vw - 2px);
      }
      &.rankNumSubColor1_1 {
        .rankNum-teamLogo-teamName {
          .rankNum {
            color: var(--mixtmt_subColor1_1);
          }
        }
      }
    }
  }

  .flexCloCenter {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .leftTeamName,
  .leftPlayerName {
    display: block;
    width: 100%;
    padding-left: 0.639vw;
    text-align: left;
    white-space: normal;
  }
  .rankNum-teamLogo-teamName,
  .teamLogo-teamName {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .rankNum {
      font-weight: bold;
      width: 2.083vw;
    }
    .teamLogo {
      width: 2.778vw;
      height: 2.778vw;
      overflow: hidden;
      border-radius: 2px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .teamName {
      width: calc(100% - 4.861vw);
      padding-left: 1.04vw;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .rankingStyleLeft {
      position: absolute;
      left: -0.347vw;
      top: 0;
      z-index: 2;
      width: 0.347vw;
      height: 100%;
    }
  }
  .teamRank_lastFive_record {
    width: 8vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-evenly;
    align-items: center;
    & > span {
      width: 1.25vw;
      height: 1.25vw;
      border-radius: 50%;
      color: var(--mixtmt_whiteColor);
      &.W {
        background-color: var(--mixtmt_teamRank_wBgColor);
      }
      &.L {
        background-color: var(--mixtmt_teamRank_lBgColor);
      }
      &.D {
        background-color: var(--mixtmt_teamRank_dBgColor);
      }
    }
  }
  .rankNum-playerLogo-playerName {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .rankNum {
      font-weight: bold;
      width: 2.083vw;
    }
    .playerLogo {
      width: 2.68vw;
      height: 3.2vw;
      overflow: hidden;
      background-image: var(--mixtmt_default_playerLogo);
      background-size: 100%;
      background-position: center bottom;
      background-repeat: no-repeat;
      object-fit: contain;
      border-radius: 2px;
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .playerName {
      width: calc(100% - 4.861vw);
      padding-left: 1.04vw;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .rankNum-playerLogo-playerName-shirtNumber {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .rankNum {
      font-weight: bold;
      width: 2.083vw;
    }
    .playerLogo {
      width: 2.68vw;
      height: 3.2vw;
      overflow: hidden;
      background-image: var(--mixtmt_default_playerLogo);
      background-size: 100%;
      background-position: center bottom;
      background-repeat: no-repeat;
      object-fit: contain;
      border-radius: 2px;
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .playerOther {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      width: calc(100% - 4.861vw);
      padding-left: 1.04vw;
      .playerName {
        width: 100%;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &.twoRow {
          padding-top: 0.347vw;
        }
      }
      .shirtNumber {
        font-weight: bold;
        width: 100%;
        text-align: left;
      }
    }
  }
  .shirtNumber-playerLogo-playerName {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .playerLogo {
      width: 2.68vw;
      height: 3.2vw;
      overflow: hidden;
      background-image: var(--mixtmt_default_playerLogo);
      background-size: 100%;
      background-position: center bottom;
      background-repeat: no-repeat;
      object-fit: contain;
      border-radius: 2px;
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .playerOther {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      width: calc(100% - 4.861vw);
      padding-left: 1.04vw;
      .playerName {
        width: 100%;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &.twoRow {
          padding-top: 0.347vw;
        }
      }
      .shirtNumber {
        font-weight: bold;
        width: 100%;
        text-align: left;
      }
    }
  }
  .marathon_scoresArr {
    position: relative;
    display: block;
    width: 100%;
    padding: 0 2.083vw;
    height: 3.32vw;
    overflow: hidden;
    &.open {
      height: auto;
      overflow: auto;
      .arrow_icon {
        transform: rotate(180deg);
      }
    }
    .scoreItem {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 0.833vw;
      line-height: 1.66vw;
    }
    .arrow_icon {
      position: absolute;
      right: 2.083vw;
      top: 1.11vw;
      z-index: 10;
    }
  }
  .rankNum-playerLogo-playerName-shirtNumber-sex {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .rankNum {
      font-weight: bold;
      width: 3.82vw;
    }
    .shirtNumber {
      font-weight: bold;
      width: 2.083vw;
    }
    .playerLogo {
      width: 2.68vw;
      height: 3.2vw;
      overflow: hidden;
      background-image: var(--mixtmt_default_playerLogo);
      background-size: 100%;
      background-position: center bottom;
      background-repeat: no-repeat;
      object-fit: contain;
      border-radius: 2px;
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .otherArea {
      width: calc(100% - 4.861vw);
      padding-left: 1.04vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      .athleteName {
        width: 100%;
        font-size: 0.833vw;
        line-height: 2.083vw;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: var(--mixtmt_greyColor3);
      }
      .numSex {
        width: 100%;
        font-size: 0.833vw;
        line-height: 1.25vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        color: var(--mixtmt_greyColor2);
      }
    }
  }
  .operateArr {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    .operateArr_btn {
      margin-left: 1.388vw;
      width: 5.556vw;
      text-align: center;
      height: 2.083vw;
      border-radius: 0.208vw;
      font-size: 0.833vw;
      line-height: 2.083vw;
      border: 1px solid var(--mixtmt_greyColor7);
      color: var(--mixtmt_greyColor_main);
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &.leagueTable {
    padding-bottom: 2.083vw;
    .el-table {
      td.el-table__cell {
        border: none;
      }
      &::before,
      .el-table__fixed-right::before,
      .el-table__fixed::before {
        height: 0;
      }
    }
  }
}

.mixtmt_pc .marathon_loadTree_table:not(.unClickDetail) {
  &.click {
    &.leftClo_notClick1 {
      .el-table {
        .mixtmt_table_header {
          th.el-table__cell {
            &:first-child {
              cursor: default;
            }
            &:not(:first-child):hover {
              background-color: var(--mixtmt_mainColor5);
              color: var(--mixtmt_table_hoverRowColor);
            }
          }
        }
      }
    }
    &.leftClo_notClick2 {
      .el-table {
        .mixtmt_table_header {
          th.el-table__cell {
            &:first-child,
            &:nth-child(2) {
              cursor: default;
            }
            &:not(:first-child):not(:nth-child(2)):hover {
              background-color: var(--mixtmt_mainColor5);
              color: var(--mixtmt_table_hoverRowColor);
            }
          }
        }
      }
    }
    &.leftClo_notClick3 {
      .el-table {
        .mixtmt_table_header {
          th.el-table__cell {
            &:first-child,
            &:nth-child(2),
            &:nth-child(3) {
              cursor: default;
            }
            &:not(:first-child):not(:nth-child(2)):not(:nth-child(3)):hover {
              background-color: var(--mixtmt_mainColor5);
              color: var(--mixtmt_table_hoverRowColor);
            }
          }
        }
      }
    }
    .el-table {
      .mixtmt_table_header {
        th.el-table__cell {
          cursor: pointer;
        }
      }
    }
  }

  .el-table__body tr.hover-row.current-row > td.el-table__cell,
  .el-table__body
    tr.hover-row.el-table__row--striped.current-row
    > td.el-table__cell,
  .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
  .el-table__body tr.hover-row > td.el-table__cell {
    background-color: var(--mixtmt_table_hoverRowColorBg);
  }
  .rankNum-playerLogo-playerName,
  .rankNum-playerLogo-playerName-shirtNumber,
  .shirtNumber-playerLogo-playerName,
  .rankNum-teamLogo-teamName,
  .teamLogo-teamName,
  .leftTeamName,
  .leftPlayerName,
  .teamName,
  .playerName,
  .matchDate-homeTeam-awayTeam,
  .operateArr_btn,
  .collectionArr_btn {
    cursor: pointer;
  }
  .operateArr_btn {
    &:hover {
      background-color: var(--mixtmt_table_headerBg);
      color: var(--mixtmt_table_headerColor);
    }
  }
  .collectionArr_btn {
    &.disabled:hover {
      background-color: var(--mixtmt_table_headerBg);
      color: var(--mixtmt_table_headerColor);
    }
    &.notDisabled:hover {
      background-color: var(--mixtmt_subColor3_1);
      color: var(--mixtmt_table_hoverRowColor);
    }
  }
  .marathon_scoresArr {
    &:hover {
      cursor: pointer;
    }
  }
  .leftPlayerName,
  .leftTeamName,
  .matchDate-homeTeam-awayTeam,
  .teamName,
  .playerName {
    &:hover {
      color: var(--mixtmt_subColor1_1);
      text-decoration: underline;
    }
  }
  .rankNum-playerLogo-playerName,
  .rankNum-playerLogo-playerName-shirtNumber,
  .shirtNumber-playerLogo-playerName {
    &:hover {
      .playerName {
        color: var(--mixtmt_subColor1_1);
        text-decoration: underline;
      }
    }
  }
  .rankNum-teamLogo-teamName,
  .teamLogo-teamName,
  .leftTeamName,
  .teamName {
    &:hover {
      .teamName {
        color: var(--mixtmt_subColor1_1);
        text-decoration: underline;
      }
    }
  }

  &.none {
    .cell {
      .rankNum-teamLogo-teamName {
        &:hover {
          cursor: default;
          .teamName {
            cursor: default;
            text-decoration: none;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
    }
  }
}
</style>
